import { useEffect, useReducer, useRef, useState } from "react";
import TextArea from "../../../components/form/TextArea";
import TextBox from "../../../components/form/TextBox";
import Map from "../../../components/here/Map";
import { API_ROUTES } from "../../../core/Constants";
import { getUSA, useHub, useScreen } from "../../../core/Global";
import WarehouseContainerModel, { ContainerRequestModel, WarehouseContainerStatus, WarehouseContainerTypes } from "../models/WarehouseContainerModel";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import AddressField from "../../../components/here/AddressField";
import DropDown from "../../../components/form/DropDown";
import Country from "../../base/models/Country";
import { HereGeocodeItem } from "../../../models/MapModels";
import PhoneInput from "../../../components/form/PhoneInput";
import PhoneItem from "../../../models/PhoneItem";
import { DrawerForm, DrawerFormRef } from "../../../components/drawers/DrawerForm";



interface IProps {
    model?: WarehouseContainerModel
    onClose: () => void
    onSave: () => void
}

export default function WarehouseContainersFormModal(props: IProps) {

    const hub = useHub()
    const screen = useScreen()

    const drawerFormRef = useRef<DrawerFormRef>(null)

    const [buildMapAdd, buildMapAddSet] = useState<boolean>(false)
    const [working, workingSet] = useState<boolean>(false)

    const [body, bodySet] = useState<ContainerRequestModel>({
        addressId: props.model?.address?.id,
        containerStatus: props.model?.operatinalStatus,
        containerType: props.model?.containerType,
        description: props.model?.description,
        id: props.model?.id,
        managerName: props.model?.managerName,
        managerPhone: props.model?.managerPhone,
        mapZoom: props.model?.mapZoom,
        name: props.model?.name,
        storageCapacity: props.model?.storageCapacity
    })

    const setCountryCache = (count: Country) => {
        window.localStorage.setItem("crm-inv-country-cache", JSON.stringify(count));
    }

    const getCountryCache = () => {
        var data = window.localStorage.getItem("crm-inv-country-cache");
        var usa = getUSA();
        if (!data || data == "") return usa;
        else return JSON.parse(data);
    }

    const [mapCountry, mapCountrySet] = useState<Country>(getCountryCache())
    const [address, addressSet] = useState<HereGeocodeItem>()
    const [managerPhone, managerPhoneSet] = useState<PhoneItem>()
    const [zoom, zoomSet] = useState<number>()
    const [selectedContainerType, selectedContainerTypeSet] = useState<WarehouseContainerTypes>()
    const [selectedContainerStatus, selectedContainerStatusSet] = useState<WarehouseContainerStatus>()

    useEffect(() => {
        bodySet({
            ...body,
            addressId: address?.id
        })
    }, [address])

    useEffect(() => {
        bodySet({
            ...body,
            managerPhone: managerPhone
        })
    }, [managerPhone])

    useEffect(() => {
        bodySet({
            ...body,
            mapZoom: zoom
        })
    }, [zoom])

    useEffect(() => {
        bodySet({
            ...body,
            containerType: selectedContainerType
        })
    }, [selectedContainerType])

    useEffect(() => {
        bodySet({
            ...body,
            containerStatus: selectedContainerStatus
        })
    }, [selectedContainerStatus])

    useEffect(() => {
        if (props.model) {
            addressSet(props.model.address)
            zoomSet(props.model.mapZoom)
            selectedContainerTypeSet(props.model.containerType)
            selectedContainerStatusSet(props.model.operatinalStatus)
            managerPhoneSet(props.model.managerPhone)
        }
    }, [props.model])

    return (
        <DrawerForm id="modal-warehouse-container-form" title="" ref={drawerFormRef}
            buttonText={props.model ? "Update Container" : "Add Container"}
            noHeader noPadding noScroll hideButtons width="90%"
            onClose={props.onClose}
            focusOn="txt-container-name"
            onOpen={() => {
                buildMapAddSet(true);
            }}
            onSubmit={(b, callback) => {

                var valid = true;

                if (!body.name || body.name.length < 2) {
                    window.formError("name", "Please write a valid name!", "modal-warehouse-container-form", true);
                    valid = false;
                }

                if (!body.containerType || body.containerType < 1) {
                    window.formError("containerType", "Please write a valid name!", "modal-warehouse-container-form");
                    valid = false;
                }

                if (!valid) {
                    if (callback) callback();
                    return;
                }

                workingSet(true)

                hub.Post(API_ROUTES.InventoryWarehouseContainers, body, res => {
                    if (res.success) {
                        props.onSave()
                    }
                    if (callback) callback(res);
                    workingSet(false)
                })

            }}>
            <div className="row">

                <div className="col-12 col-md-7 px-8">

                    <FlexRow className="py-4 py-xxl-6 border-bottom-0">
                        <h2 className="fs-1 fs-xxxl-1 modal-title d-flex align-items-center">
                            {props.model ? "Edit Container" : "Create Container"}
                        </h2>
                        <button type="button" className="btn btn-icon btn-sm btn-active-icon-primary ms-auto" title="Close"
                            onClick={e => {
                                e.preventDefault()
                                drawerFormRef.current?.close()
                            }}>
                            <Icon icon="times" type="thin" className="fs-1 fs-xxxl-1" />
                        </button>
                    </FlexRow>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <TextBox id="txt-container-name" name="name" label="Container Name *"
                                marginBottom={5} labelUp block placeholder="E.g. Main Wairhouse, South Unit, Van 5..."
                                value={props.model?.name}
                                onTextChanges={e => bodySet({
                                    ...body,
                                    name: e
                                })} />
                        </div>
                        <div className="col-12 col-md-6">
                            <DropDown id="drp-container-type" name="containerType" label="Container Type *"
                                labelUp block marginBottom={5} forceSelectValue={selectedContainerType?.toString()}
                                onSelectItem={e => selectedContainerTypeSet(e.id)} parentModal="modal-warehouse-container-form"
                                source={[
                                    {
                                        id: 1,
                                        name: "Distribution Center"
                                    },
                                    {
                                        id: 2,
                                        name: "Storage Facility"
                                    },
                                    {
                                        id: 3,
                                        name: "Retail Outlet"
                                    },
                                    {
                                        id: 4,
                                        name: "Mobile Unit"
                                    }
                                ]} />
                        </div>
                        <div className="col-12">
                            <AddressField id="txt-container-address" label="Address" name="address" block labelUp verify
                                defaultCountry={getCountryCache()} country={mapCountry}
                                addressId={props.model?.address?.id}
                                selectedAddress={address}
                                placeholder="Search by Zip Code, Building Number, Street..."
                                parent="modal-warehouse-container-form"
                                onCountrySelect={c => mapCountrySet(c)}
                                onSelect={e => addressSet(e)}
                                onUnselect={() => addressSet(undefined)}
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <TextBox id="txt-container-managername" name="managerName" label="Manager Name"
                                marginBottom={5} labelUp block value={props.model?.managerName}
                                onTextChanges={e => bodySet({
                                    ...body,
                                    managerName: e
                                })} />
                        </div>
                        <div className="col-12 col-md-6">
                            <PhoneInput id="container-managerphone" name="managerPhone" label="Manager Phone"
                                marginBottom={5} labelUp block defaultPhone={props.model?.managerPhone}
                                onComplete={e => managerPhoneSet(e)}
                                onInComplete={() => managerPhoneSet(undefined)} />
                        </div>
                        <div className="col-12 col-md-6">
                            <TextBox id="txt-container-capacity" name="storageCapacity" label="Storage Capaticy"
                                marginBottom={5} labelUp block placeholder="Sq ft, Cubic meters..."
                                value={props.model?.storageCapacity}
                                onTextChanges={e => bodySet({
                                    ...body,
                                    storageCapacity: e
                                })} />
                        </div>
                        <div className="col-12 col-md-6">
                            <DropDown id="drp-container-status" name="containerStatus" label="Operational Status"
                                labelUp block marginBottom={5} onSelectUpdate={body} parentModal="modal-warehouse-container-form"
                                forceSelectValue={selectedContainerStatus?.toString()}
                                onSelectItem={e => selectedContainerStatusSet(e.id)}
                                source={[
                                    {
                                        id: 1,
                                        name: "Active"
                                    },
                                    {
                                        id: 2,
                                        name: "Inactive"
                                    },
                                    {
                                        id: 3,
                                        name: "Under Maintenance"
                                    }
                                ]} />
                        </div>
                    </div>

                    <TextArea id="add-vendor-descr" name="description"
                        label="Description" labelUp block rows={6}
                        value={props.model?.description}
                        placeholder="Write a description (optional)"
                        onChange={e => bodySet({
                            ...body,
                            description: e.target.value
                        })} />


                    <FlexRow justify="end" className="border-top pt-xxl-6 mt-xxl-6 pt-2 mt-2">
                        <button type="button" className="btn btn-secondary btn-sm me-2" disabled={working}
                            onClick={e => {
                                e.preventDefault();
                                drawerFormRef.current?.close()
                            }}>
                            Discard
                        </button>
                        <button className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">
                                            Please Wait
                                        </span>
                                    </>
                                    :
                                    <>
                                        {props.model ? "Update Container" : "Add Container"}
                                    </>
                            }
                        </button>
                    </FlexRow>
                </div>

                <div className="col-12 col-md-5">
                    <Map id="container-form-map" height={screen.height} zoom={body.mapZoom}
                        build={buildMapAdd} country={mapCountry}
                        draggableMarker={address?.position}
                        draggableMarkerIcon="container"
                        onMarkerUpdated={e => addressSet(e)}
                        onZoomChanged={z => zoomSet(z)} />
                </div>



            </div>
        </DrawerForm>
    )
}